const HIGHER_QUANTITY = 1;

export { HIGHER_QUANTITY as H };
